(function (Drupal, once) {
    'use strict';

    
    Drupal.behaviors.stepsSlider = {
        attach: function (context) {
            const slider = once('steps-slider', '.participation-steps__items .swiper', context)[0];
            if (!slider) return;

            if (typeof Swiper === 'undefined') {
                console.warn('Swiper library not loaded');
                return;
            }

            const paginationEl = slider.querySelector('.swiper-pagination');

            const options = {
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                spaceBetween: 42,
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                        loop: true,
                        centeredSlides: true
                    },
                    768: {
                        slidesPerView: 2,
                        centeredSlides: false,
                        loop: true
                    },
                    992: {
                        slidesPerView: 3,
                        loop: false,
                        centeredSlides: false
                    }
                },
                pagination: {
                    el: paginationEl || undefined,
                    clickable: true,
                },
                on: {
                    breakpoint: function (swiper) {
                        if (window.innerWidth >= 992) {
                            swiper.disable();
                            swiper.el.classList.add('swiper-disabled');
                        } else {
                            swiper.enable();
                            swiper.el.classList.remove('swiper-disabled');
                            swiper.update();
                        }
                    }
                }
            };

            try {
                const swiperInstance = new Swiper(slider, options);
                slider.classList.add('is-swiper-active');

                if (window.innerWidth >= 992) {
                    swiperInstance.disable();
                    slider.classList.add('swiper-disabled');
                }
            } catch (error) {
                console.error('Failed to initialize Swiper:', error);
            }
        }
    };

})(Drupal, once);